import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-auto no-print mb-16 md:mb-0">
      <div className="max-w-7xl mx-auto px-4 py-6 md:px-6">
        <div className="text-center space-y-3">
          <p className="text-sm font-semibold text-gray-800 dark:text-gray-200">
            {t('footer.copyright')}
          </p>
          <p className="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
            {t('footer.disclaimer')}
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {t('footer.developed')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
